var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "check"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.00004 13.25C5.89933 13.2466 5.80037 13.2227 5.70924 13.1797C5.6181 13.1367 5.5367 13.0756 5.47004 13L0.470037 8.00003C0.374705 7.93822 0.294662 7.85556 0.235951 7.75829C0.177239 7.66102 0.141395 7.55168 0.131123 7.43853C0.120852 7.32538 0.136421 7.21137 0.176657 7.10512C0.216893 6.99887 0.280743 6.90315 0.363386 6.82518C0.44603 6.74721 0.545307 6.68904 0.653721 6.65506C0.762136 6.62108 0.876854 6.61217 0.989215 6.62901C1.10158 6.64585 1.20864 6.688 1.30233 6.75227C1.39602 6.81654 1.47388 6.90126 1.53004 7.00003L6.00004 11.44L16.47 1.00003C16.611 0.908639 16.7786 0.867218 16.9459 0.882406C17.1132 0.897593 17.2705 0.96851 17.3927 1.08379C17.5149 1.19907 17.5949 1.35203 17.6198 1.51817C17.6447 1.68431 17.6131 1.85399 17.53 2.00003L6.53004 13C6.46337 13.0756 6.38197 13.1367 6.29084 13.1797C6.1997 13.2227 6.10075 13.2466 6.00004 13.25Z",
    fill: "#1F2937"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.67f51a5fa4b6a4c77a66d2b2c58f3d48.svg";
export { ForwardRef as ReactComponent };